function fn_scrollreveal() {
    if ($(window).width() > 1024 && !$("html.sr").length) {
        window.sr = ScrollReveal({ duration: 2000 });
        if (sr.isSupported()) {
            document.documentElement.classList.add('sr');
        }
        sr.reveal('[data-reveal-fade]', {
            duration: 500,
            easing: 'ease-in',
            scale: 1,
            distance: 0,
            delay: 250,
            viewFactor  : 0.1,
            afterReveal: function (domEl) {
                $(domEl).addClass("revealed");
            }
        }, 0);
    }
}